export default __webpack_public_path__ + "static/media/refresh.8505f46c.svg";